<template>
  <div class="price-report-wrapper">
    <div class="price-report-card">
      <!-- 顶部操作栏 -->
      <div class="operation-header">
        <h2 class="title">
          <i class="el-icon-notebook-2"></i>
          上报记录
        </h2>
        <div class="action-buttons">
          <el-button
            type="primary"
            @click="createPrice"
            class="action-btn primary-btn"
          >
            手动上报
          </el-button>
          <el-tooltip content="下载Excel模板" placement="top">
            <el-button
              icon="el-icon-download"
              class="action-btn"
              @click="downloadTemplate"
            >
              下载模板
            </el-button>
          </el-tooltip>
          <el-button
            icon="el-icon-upload2"
            class="action-btn"
            @click="showImportDialog"
          >
            导入数据
          </el-button>
        </div>
      </div>

      <!-- 数据表格区域 -->
      <div class="table-container">
        <el-table
          ref="recordsTable"
          :data="reportRecords"
          highlight-current-row
          style="width: 100%"
          :header-cell-style="{
            background: '#f8fafc',
            color: '#606266',
            fontWeight: '600',
          }"
          :cell-style="{ padding: '16px 0' }"
          empty-text="暂无上报记录"
          class="elegant-table"
        >
          <el-table-column
            type="index"
            label="序号"
            width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="enterpriseName"
            label="企业名称"
            width="400"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="priceDate"
            label="价格时间"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="gmtCreated"
            label="上报时间"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleClick(scope.row)"
                class="detail-btn"
              >
                <i class="el-icon-document"></i> 查看上报详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 导入数据弹窗 -->
    <el-dialog
      title="导入价格数据"
      :visible.sync="importDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="resetImportForm"
    >
      <el-form label-width="100px">
        <el-form-item label="价格日期" required>
          <el-date-picker
            v-model="importDate"
            type="date"
            placeholder="请选择价格日期"
            value-format="yyyy-MM-dd"
            :picker-options="datePickerOptions"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="数据文件" required>
          <el-upload
            class="upload-demo"
            drag
            action=""
            :limit="1"
            :on-change="handleFileChange"
            :auto-upload="false"
            accept=".xlsx,.xls"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传xlsx/xls文件，且不超过10MB
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitImport"
          :disabled="!importDate || !selectedFile"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 弹窗组件 -->
    <createPriceDialog
      :priceVisible.sync="priceVisible"
      v-if="priceVisible"
      :currentPriceVersion="currentPriceVersion"
      :mode="dialogPriceMode"
      @updateRecord="updateRecord"
    />
  </div>
</template>
<script>
import { getHistoryReport, importPriceDate } from '@/API/price/price.js';
import createPriceDialog from '@/views/reportPage/createPriceDialog.vue';
import axios from 'axios';


export default {
  components: {
    createPriceDialog,
  },
  data() {
    return {
      reportRecords: [], // 记录数据
      dialogPriceMode: 'create', // 弹窗模式
      pageNum: 1,
      pageSize: 20,
      currentPriceVersion: 0, // 当前选中上报价格版本号
      priceVisible: false, // 弹窗是否显示
      reportDate: '', // 导入价格日期

      importDialogVisible: false, // 控制导入弹窗显示
      importDate: '', // 导入的价格日期
      selectedFile: null, // 存储选择的文件
      fileList: [], // 上传文件列表
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          },
        ],
      },
    };
  },
  created() {
    this.getReportRecords();
  },
  methods: {
    getReportRecords() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      getHistoryReport(params).then((res) => {
        if (res.code == 200) {
          if (res.data && res.data.length) {
            let userInfo = localStorage.getItem('ordinaryUser');
            let enterpriseInfo =
              JSON.parse(userInfo).userDetail?.enterpriseInfo;
            res.data.forEach((item) => {
              item.enterpriseName = enterpriseInfo.companyName;
            });
          }
          this.reportRecords = res.data;
        }
      });
    },
    // 上报价格
    createPrice() {
      this.dialogPriceMode = 'create';
      this.priceVisible = true;
      this.currentPriceVersion = 0;
    },
    // 查看详情
    handleClick(row) {
      this.priceVisible = true;
      this.dialogPriceMode = 'detail';
      this.currentPriceVersion = row.version;
      console.log('row');
    },
    // 更新纪录列表
    updateRecord() {
      this.pageNum = 1;
      this.pageSize = 20;
      this.getReportRecords();
    },
    // 下载模板
    async downloadTemplate() {
      console.log('下载模板');
      try {
        const response = await axios.get(
          process.env.VUE_APP_API_BASE + '/resource/api/data/template/download/3',
          {
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${localStorage.getItem('ordinaryToken')}`,
            },
          },
        );
        if(response && response.status !== 200){
          this.$message.error('下载失败');
          return
        }
        // 替代方案：直接使用后端返回的文件名
        const fileName = response.headers['content-disposition']
          ? response.headers['content-disposition'].split('filename=')[1]
          : 'templete.xlsx';
        // 创建对象URL的替代方案
        const fileReader = new FileReader();
        fileReader.onload = (event) => {
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = event.target.result;
          a.download = '价格数据上报模版' + '.' + fileName.split('.')[1];
          // a.download = '价格数据上报模版.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
        fileReader.readAsDataURL(response.data);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
    // 显示导入弹窗
    showImportDialog() {
      this.importDialogVisible = true;
    },
    // 处理文件选择
    handleFileChange(file, fileList) {
      this.selectedFile = file.raw;
      this.fileList = fileList.slice(-1); // 只保留最新文件
    },
    // 提交导入
    submitImport() {
      if (!this.selectedFile || !this.importDate) {
        this.$message.warning('请选择文件和价格日期');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('priceDate', this.importDate);

      this.$loading({ lock: true, text: '正在导入数据...' });
      console.log('77777777777', this.importDate, formData)
      importPriceDate(this.importDate, formData)
        .then((res) => {
          if (res.code === 200) {
            // const successMsg = `导入成功${res.data.successCount || 0}条`;
            // const failMsg = res.data.failCount
            //   ? `，失败${res.data.failCount}条`
            //   : '';
            this.$message.success('导入成功');
            this.getReportRecords(); // 刷新数据
            this.importDialogVisible = false;
          } else {
            this.$message.error(res.message || '导入失败');
          }
        })
        .catch((err) => {
          console.error('导入失败:', err);
          this.$message.error('导入失败');
        })
        .finally(() => {
          this.$loading().close();
          this.resetImportForm();
        });
    },
    // 重置导入表单
    resetImportForm() {
      this.importDate = '';
      this.selectedFile = null;
      this.fileList = [];
    },
  },
};
</script>
<style lang="less" scoped>
.price-report-wrapper {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 60px);
  padding: 24px;
  background-color: #f5f7fa;

  .price-report-card {
    width: 100%;
    max-width: 1200px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    padding: 24px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
  }

  .operation-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f2f5;

    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #303133;
      display: flex;
      align-items: center;

      i {
        margin-right: 10px;
        color: #409eff;
        font-size: 24px;
      }
    }

    .action-buttons {
      display: flex;
      gap: 12px;

      .action-btn {
        padding: 10px 16px;
        border-radius: 6px;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
        }
      }

      .primary-btn {
        background: linear-gradient(135deg, #409eff, #66b1ff);
        border: none;
      }
    }
  }

  .table-container {
    margin: 0 auto;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid #ebeef5;

    .elegant-table {
      ::v-deep .el-table__header-wrapper {
        th {
          font-weight: 600;
          letter-spacing: 0.5px;
        }
      }

      ::v-deep .el-table__body-wrapper {
        .el-table__row {
          transition: background-color 0.3s;

          &:hover {
            background-color: #f8fafc;
          }

          .cell {
            .company-name {
              font-weight: 500;
              color: #303133;
            }
          }
        }
      }

      .detail-btn {
        color: #409eff;
        padding: 8px 12px;
        border-radius: 4px;
        transition: all 0.3s;

        i {
          margin-right: 6px;
        }

        &:hover {
          background: rgba(64, 158, 255, 0.1);
          color: #66b1ff;
        }
      }

      ::v-deep .el-table__empty-block {
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-table__empty-text {
          color: #909399;
          font-size: 16px;
        }
      }
    }
  }
}

.upload-demo {
  ::v-deep .el-upload {
    width: 100%;

    .el-upload-dragger {
      width: 100%;
      padding: 20px;
    }
  }
}

.dialog-footer {
  text-align: right;
}

@media (max-width: 992px) {
  .price-report-wrapper {
    padding: 16px;

    .price-report-card {
      padding: 16px;
    }

    .operation-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;

      .action-buttons {
        width: 100%;
        flex-wrap: wrap;
      }
    }

    .table-container {
      overflow-x: auto;
    }
  }
}
</style>